import { lenis } from "./lenis";

export default (ref) => {
  const app = document.getElementById("machine-3d");

  if (!app) return;

  const images = app.querySelectorAll(".locking");
  const easings = Array.from(app.querySelectorAll(".easing"));
  const easingPair = easings.map((parent) => ({
    parent,
    child: parent.firstElementChild,
  }));

  const easeOutQuad = (t) => t * (2 - t);
  const easeOutCubic = (t) => --t * t * t + 1;
  const clamp = (min, val, max) => Math.max(min, Math.min(max, val));

  const [lockingStart, lockingEnd] = [70, 200];

  function update() {
    const { top, bottom } = app.parentElement.getBoundingClientRect();

    function playLockingSequence() {
      const vhScrolled = ((top * -1) / window.innerHeight) * 100;
      const value = (vhScrolled - lockingStart) / (lockingEnd - lockingStart);
      const lockingProgress = clamp(0, value, 1);
      const activeImageIndex = Math.round(
        lockingProgress * (images.length - 1),
      );

      images.forEach((image, idx) => {
        (image as HTMLElement).style.opacity =
          idx === activeImageIndex ? "1" : "0";
      });
    }

    playLockingSequence();

    // the bottle asset should not be visible above the locking-assets top border
    function clipBottle() {
      if (!ref["3dBottle"]?.[0]) return;

      const { height } = ref["3dBottle"][0].getBoundingClientRect();
      const target = ref["3dBottle"][0].parentElement.parentElement;
      const { top } = target.getBoundingClientRect();

      const trigger = 0.18;
      const start = top / height;
      const value = 9 - (start / trigger) * (window.innerWidth < 798 ? 20 : 10);

      app.style.setProperty(
        "--bottle-mask",
        Math.max(90, 100 - value).toString() + "%",
      );
    }

    clipBottle();

    if (window.innerWidth < 798) return;

    function applyEasingToEachElement() {
      easingPair.forEach((pair) => {
        const { parent, child } = pair;
        const { top } = parent.getBoundingClientRect();

        // px's from sticky position where the element starts slowing down
        const ease = 300;

        // amount of slow-effect
        const slow = 4;

        if (top > ease) {
          (child as HTMLElement).style.transform =
            `matrix(1, 0, 0, 1, 0, ${-ease / slow})`;
          return;
        }

        // if (top === 0) {
        //   (child as HTMLElement).style.removeProperty("transform");
        //   return;
        // }

        const progress = (ease - (ease - top)) / ease;

        // slows the elements when approaching sticky position
        const eased = easeOutCubic(progress);

        (child as HTMLElement).style.transform =
          `matrix(1, 0, 0, 1, 0, ${clamp(-ease, (eased / slow) * -ease, 0)})`;
      });
    }

    function applyEasingToWholeContainer() {
      if (bottom < window.innerHeight) {
        const value = (window.innerHeight - bottom) / window.innerHeight;
        const progress = clamp(0, value, 1);
        const eased = easeOutQuad(progress);
        app.style.transform = `matrix(1, 0, 0, 1, 0, ${eased * 400})`;
      }
    }

    applyEasingToEachElement();
    applyEasingToWholeContainer();
  }

  const teardown = lenis.on("scroll", update);

  update();

  return teardown;
};
